import type {
    DocumentPartsResponse,
    InlineRelationsResponse,
} from "../types";
import {PanelDocumentParts} from "./PanelDocumentParts";
import type {PanelItem} from "./PanelContext";
import {PanelInlineRelations} from "./PanelInlineRelations";

export const PanelContent = ({item}: {item: PanelItem}) => {
    if (item.fetchType === "documentParts") {
        return (
            <PanelDocumentParts
                data={item.data as DocumentPartsResponse}
                request={item.params}
            />
        );
    }

    if (item.fetchType === "inlineRelations") {
        return (
            <PanelInlineRelations
                data={item.data as InlineRelationsResponse}
                title={item.label}
            />
        );
    }

    return null;
};
